import React from 'react';
import Skeleton from "react-loading-skeleton";

function RestaurantFavouritesSkeleton(){
    return(
        <div style={{lineHeight: 1}}>
            <Skeleton style={{width:"100%"}} height={494} />
        </div>
    );
}
export default RestaurantFavouritesSkeleton;